<div class="m-portlet m-portlet--mobile m-portlet--body-progress-">

	<div class="m-portlet__body" [formGroup]="facilitySelectUploadForm">
		<div class="row margin-10">
			<div class="col-lg-12">
				<h4>Facilities Available at the Centre:</h4>
				<p>Allowed formats pdf, jpeg, png or jpg</p>
			</div>
		</div>
		<div class="row flex-row margin-15">
			<div class="col-md-6" *ngFor="let checkbox of checkBoxes">
				<div class="row">


					<div class="col-lg-4">
						<div class="m-form__group form-group">
							<div class="m-checkbox-list">
								<label class="m-checkbox">
									<input type="checkbox" [formControlName]="checkbox.name" [value]="checkbox.name">
									{{checkbox.label}}
									<b class="mandatoryColor" *ngIf="checkbox.required">*</b>
									<span></span>
								</label>
							</div>
						</div>
					</div>
					<div class="col-lg-6">
						<!-- <ng-container *ngIf="this.facilitySelectUploadForm.get(checkbox.name).value">
							<ng-container *ngIf='forDownload'>
								<app-file-download
									[fileURL]="this.facilitySelectUploadForm.get(checkbox.documentName).value">
								</app-file-download>
							</ng-container> -->
							<!-- <ng-container *ngIf='!forDownload'>
								<app-upload-file [showAstrisk]="showAstrisk" [formValue]="this.facilitySelectUploadForm.get(checkbox.documentName)"
									fileType="facilityFile" [(localFile)]="localFileName[checkbox.name]"
									[(localFileValue)]="localFileName[checkbox.documentName]"></app-upload-file>
								<input type="hidden" [formControlName]="checkbox.name" #fileInput>
								<app-form-control-messages
									[control]="facilitySelectUploadForm.get(checkbox.documentName)"
									[name]="checkbox.errorName"></app-form-control-messages>
							</ng-container> -->
						<!-- </ng-container> -->
					</div>
				</div>
			</div>
		</div>